import React, {Component} from 'react';
import Header from "./components/Header";
import Footer from "./components/Footer";
import Content from "./components/Content";

class Layout extends Component {

    constructor(props, context) {
        super(props, context);

    }

    render() {
        return (

            <div>
                <Header></Header>
                <Content></Content>
                <Footer></Footer>

            </div>
        );
    }
}

export default Layout;
